import * as React from 'react';

import TranslationActions from 'actions/TranslationActions';
// @ts-ignore
import LanguageHoverCard from 'chat/components/LanguageHoverCard';
import errorLogger from 'utils/errorLogger';

import TooltipHovercardIconButton from './TooltipHovercardIconButton';

export type Props = {
  onTextChange?: (text: string) => void;
  onLangChange?: (lang: string) => void;
  textToTranslate: string;
  className?: string;
  eventKey?: string;
  eventProperties?: { [key: string]: any };
  dataTestSelector?: string;
};

class TranslateButton extends React.Component<Props> {
  handleTranslateTo = (
    lang: string,
    text: string,
    onTextChange?: (text: string) => void,
    onLangChange?: (lang: string) => void
  ) => {
    TranslationActions.translate(text, lang)
      .then(response => {
        if (onLangChange) {
          onLangChange(lang);
        }
        if (onTextChange) {
          onTextChange(response.translation);
        }
      })
      .catch(errorLogger('TranslateButton translate failed'));
  };

  render() {
    const { textToTranslate, onTextChange, onLangChange, ...props } = this.props;
    const disabled = !textToTranslate;
    return (
      <TooltipHovercardIconButton
        icon="globe-stroked"
        disabled={disabled}
        layer={
          <LanguageHoverCard
            onLanguagePicked={(lang: string) =>
              this.handleTranslateTo(lang, textToTranslate, onTextChange, onLangChange)
            }
          />
        }
        tooltipText={disabled ? 'Type your message to translate it' : 'Translate'}
        {...props}
      />
    );
  }
}

export default TranslateButton;
